import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SavedTracks from './SavedTracks';
import SavedHighlights from './SavedHighlights';
import SegmentedTabs from './SegmentedTabs';
import './SavedHighlights.css';

const noop = () => {};

const SAVED_CONTENT_OPTIONS = [
    { value: 'episodes', label: 'Episodes' },
    { value: 'highlights', label: 'Highlights' },
];

export default function SavedLibrary(props) {
    const location = useLocation();
    const [type, setType] = useState(() => {
        try { return localStorage.getItem('saved-content-type') === 'highlights' ? 'highlights' : 'episodes'; } catch (_) { return 'episodes'; }
    });
    const [listId, setListId] = useState(location.state?.selectedSavedListId || null);
    const [selectionMode, setSelectionMode] = useState(false);
    const [selectionBusy, setSelectionBusy] = useState(false);
    const session = useSelector(state => state.savedHighlights.session);
    const { onSelectionModeChange = noop } = props;
    useEffect(() => { setSelectionMode(false); setSelectionBusy(false); }, [session]);
    useEffect(() => { onSelectionModeChange(selectionMode); }, [onSelectionModeChange, selectionMode]);
    useEffect(() => () => onSelectionModeChange(false), [onSelectionModeChange]);
    const toggle = <div className='savedContentToggle' role='group' aria-label='Saved content'>
        <SegmentedTabs
            options={SAVED_CONTENT_OPTIONS}
            selectedValue={type}
            disabled={selectionBusy}
            fontSize='15px'
            buttonPadding='10px 12px'
            onChange={value => {
                setType(value);
                try { localStorage.setItem('saved-content-type', value); } catch (_) { /* Optional preference. */ }
            }}
        />
    </div>;
    const selectionProps = { selectionMode, onSelectionModeChange: setSelectionMode, onSelectionActionChange: setSelectionBusy };
    return type === 'highlights' ? <SavedHighlights key={session} {...props} {...selectionProps} toggle={toggle} listId={listId} onListChange={setListId} />
        : <SavedTracks key={session} {...props} {...selectionProps} contentToggle={toggle} initialListId={listId} onListChange={setListId} />;
}
